import { Injectable, inject } from '@angular/core';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';

import { StorageService } from '@shared/services';
import { Timesheet } from '../types/timesheet';

@Injectable({
  providedIn: 'root'
})
export class TimesheetStorageService {
  private storage = inject(StorageService);



  get(): Observable<Timesheet[]> {
    return from(this.storage.get('timesheets.current'))
      .pipe(
        map(timesheets => timesheets ? timesheets : []),
      );
  }

  save(timesheets: Timesheet[]): Observable<any> {
    return from(this.storage.set('timesheets.current', timesheets));
  }

}
